(() => {
  'use strict';
  if (!document.body.classList.contains('page-index')) return;

  const syncStoryHeadingStyle = () => {
    const source = document.getElementById('StoryTitle');
    if (!source) return;

    const sourceStyle = getComputedStyle(source);
    const maskImage = sourceStyle.getPropertyValue('-webkit-mask-image') || sourceStyle.getPropertyValue('mask-image');
    const maskSize = sourceStyle.getPropertyValue('-webkit-mask-size') || sourceStyle.getPropertyValue('mask-size') || '2.25em 1.5em';
    const maskRepeat = sourceStyle.getPropertyValue('-webkit-mask-repeat') || sourceStyle.getPropertyValue('mask-repeat') || 'repeat';
    const maskPosition = sourceStyle.getPropertyValue('-webkit-mask-position') || sourceStyle.getPropertyValue('mask-position') || '0% 0%';

    document.querySelectorAll('.sba-heading h2, .sba-panel--tents-shelters .sba-panel-head h3, .sba-why-head h2').forEach((title) => {
      title.style.setProperty('font-family', sourceStyle.fontFamily, 'important');
      title.style.setProperty('font-weight', sourceStyle.fontWeight, 'important');
      title.style.setProperty('font-style', sourceStyle.fontStyle, 'important');
      title.style.setProperty('text-transform', 'uppercase', 'important');
      title.style.setProperty('letter-spacing', '-.01em', 'important');
      title.style.setProperty('line-height', '.95', 'important');
      title.style.setProperty('transform', 'skewX(-9deg)', 'important');
      title.style.setProperty('transform-origin', 'center center', 'important');
      title.style.setProperty('color', sourceStyle.color, 'important');
      title.style.setProperty('text-shadow', sourceStyle.textShadow, 'important');

      if (maskImage && maskImage !== 'none') {
        title.style.setProperty('-webkit-mask-image', maskImage, 'important');
        title.style.setProperty('mask-image', maskImage, 'important');
        title.style.setProperty('-webkit-mask-size', maskSize, 'important');
        title.style.setProperty('mask-size', maskSize, 'important');
        title.style.setProperty('-webkit-mask-repeat', maskRepeat, 'important');
        title.style.setProperty('mask-repeat', maskRepeat, 'important');
        title.style.setProperty('-webkit-mask-position', maskPosition, 'important');
        title.style.setProperty('mask-position', maskPosition, 'important');
      }
    });
  };

  const syncBuiltForWildColor = () => {
    const source = document.getElementById('EntranceTitle');
    const color = source ? getComputedStyle(source).color : '#f3ecdc';

    document.querySelectorAll([
      '#StoryTitle',
      '.sba-heading h2',
      '.sba-panel--tents-shelters .sba-panel-head h3',
      '.sba-why-head h2',
      '.brand-story-copy .eyebrow',
      '#ConnectionTitle'
    ].join(',')).forEach((title) => {
      title.style.setProperty('color', color, 'important');
    });
  };

  const syncAdventureEyebrowColor = () => {
    const source = document.querySelector('.sba-heading .eyebrow');
    const target = document.querySelector('.sba-why-eyebrow');
    if (!source || !target) return;
    target.style.setProperty('color', getComputedStyle(source).color, 'important');
  };

  requestAnimationFrame(() => {
    syncStoryHeadingStyle();
    syncBuiltForWildColor();
    syncAdventureEyebrowColor();
  });

  const selectors = [
    '.story-content > *',
    '.story-aside',
    '.sba-heading',
    '.sba-tabs',
    '.sba-controller',
    '.sba-why-head',
    '.sba-why-card',
    '.camp-pathways .section-heading',
    '.camp-pathways .pathway',
    '.camp-pathways > .wrap > .small',
    '.brand-story-copy'
  ];

  const nodes = [...document.querySelectorAll(selectors.join(','))];
  if (!nodes.length) return;

  nodes.forEach((node, index) => {
    node.classList.add('journey-reveal');
    node.style.setProperty('--journey-delay', `${Math.min(index % 4, 3) * 70}ms`);
  });

  if (window.matchMedia('(max-width: 749px), (pointer: coarse)').matches || window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) {
    nodes.forEach((node) => node.classList.add('is-visible'));
    return;
  }

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-visible');
      observer.unobserve(entry.target);
    });
  }, { rootMargin: '0px 0px -10% 0px', threshold: 0.08 });

  nodes.forEach((node) => observer.observe(node));
})();

